// Login sayfası - Kullanıcı girişi
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { FiEye, FiEyeOff, FiMail, FiLock, FiUser, FiClock, FiMapPin, FiCheck } from 'react-icons/fi';
import LoadingSpinner from '../../components/Common/LoadingSpinner';
import toast from 'react-hot-toast';

const Login = () => {
  const { login, loading } = useAuth();
  const { isDarkMode } = useTheme();
  const [formData, setFormData] = useState({
    username: '',
    password: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});

  // Form değişikliklerini yönet
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Hata mesajını temizle
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    
  };

  // Form gönderimi
  const handleSubmit = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    
    // Validation
    const newErrors = {};
    if (!formData.username.trim()) {
      newErrors.username = 'Kullanıcı adı gerekli';
    }
    if (!formData.password.trim()) {
      newErrors.password = 'Şifre gerekli';
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    try {
      await login(formData);
    } catch (error) {
      console.error('Login hatası:', error);
      toast.error('Kullanıcı adı veya şifre hatalı. Lütfen tekrar deneyin.', {
        duration: 4000,
        position: 'top-center',
        style: {
          background: '#fef2f2',
          color: '#dc2626',
          border: '1px solid #fecaca',
        },
      });
    }
  };

  return (
    <div className="min-h-screen flex">
      {/* Sol taraf - Arka plan görseli */}
      <div 
        className="hidden lg:flex lg:w-3/5 relative overflow-hidden items-center justify-center"
        style={{ backgroundColor: '#dce6ff' }}
      >
        {/* Arka plan görseli - büyütülmüş ve ortalanmış */}
        <div 
          className="w-3/5 h-3/5 bg-contain bg-center bg-no-repeat"
          style={{
            backgroundImage: 'url(/login_background.jpg)',
            backgroundSize: 'contain',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
          }}
        ></div>
      </div>

      {/* Sağ taraf - Login formu */}
      <div className="w-full lg:w-2/5 flex items-center justify-center bg-white p-4 sm:p-8">
        <div className="w-full max-w-md space-y-6 sm:space-y-8">
          {/* Logo */}
          <div className="text-left">
            <div className="mb-4">
              {/* APRO login logosu */}
              <img 
                src="/apro_login_logo.png" 
                alt="APRO Login Logo" 
                className="w-auto h-16 object-contain"
              />
            </div>
          </div>

          {/* Login formu */}
          <div className="space-y-6" onKeyDown={(e) => e.key === 'Enter' && handleSubmit(e)}>
            {/* E-posta alanı */}
            <div className="space-y-2">
              <label htmlFor="username" className="block text-sm font-semibold text-gray-700">
                E-mail
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <FiMail className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                </div>
                <input
                  id="username"
                  name="username"
                  type="text"
                  value={formData.username}
                  onChange={handleChange}
                  className={`w-full pl-12 pr-4 py-3 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 ${
                    errors.username 
                      ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
                      : 'border-gray-300'
                  }`}
                  placeholder="Enter email"
                />
              </div>
              {errors.username && (
                <p className="text-sm text-red-600 flex items-center">
                  <span className="w-1 h-1 bg-red-600 rounded-full mr-2"></span>
                  {errors.username}
                </p>
              )}
            </div>

            {/* Şifre alanı */}
            <div className="space-y-2">
              <label htmlFor="password" className="block text-sm font-semibold text-gray-700">
                Password
              </label>
              <div className="relative group">
                <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                  <FiLock className="h-5 w-5 text-gray-400 group-focus-within:text-blue-500 transition-colors" />
                </div>
                <input
                  id="password"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  value={formData.password}
                  onChange={handleChange}
                  className={`w-full pl-12 pr-12 py-3 border-2 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 ${
                    errors.password 
                      ? 'border-red-500 focus:ring-red-500 focus:border-red-500' 
                      : 'border-gray-300'
                  }`}
                  placeholder="Enter password"
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-4 flex items-center hover:text-blue-500 transition-colors"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <FiEyeOff className="h-5 w-5 text-gray-400" />
                  ) : (
                    <FiEye className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
              {errors.password && (
                <p className="text-sm text-red-600 flex items-center">
                  <span className="w-1 h-1 bg-red-600 rounded-full mr-2"></span>
                  {errors.password}
                </p>
              )}
            </div>

            {/* Şifremi unuttum linki */}
            <div className="text-right">
              <Link
                to="/forgot-password"
                className="text-sm text-gray-600 hover:text-blue-500 font-medium transition-colors duration-200"
              >
                Forgot password?
              </Link>
            </div>

            {/* Giriş butonu */}
            <button
              type="button"
              onClick={handleSubmit}
              disabled={loading}
              className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 px-4 rounded-lg font-semibold transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed shadow-lg"
            >
              {loading ? (
                <div className="flex items-center justify-center">
                  <LoadingSpinner size="small" text="" />
                  <span className="ml-2">Giriş yapılıyor...</span>
                </div>
              ) : (
                'Login'
              )}
            </button>
          </div>

          {/* Footer */}
          <div className="text-center pt-4 sm:pt-8">
            <p className="text-xs sm:text-sm text-gray-500">
            All rights reserved. © Copyright 2025 | APRO
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
